import React, { useEffect, useState } from "react";
import { api, formatPrice } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import { Pencil, Users, BadgePercent } from "lucide-react";
import { toast } from "sonner";

export default function AdminCustomers({ loyalty = false }) {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/customers").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try { await api.put(`/admin/customers/${edit.id}`, { discount_percent: edit.discount_percent, note: edit.note }); toast.success("Запазено"); setEdit(null); load(); }
    catch { toast.error("Грешка"); }
  };

  return (
    <div data-testid={loyalty ? "admin-loyalty" : "admin-customers"}>
      <PageHead title={loyalty ? "Лоялна програма" : "Клиенти"}
        desc={loyalty ? "Задайте персонална % отстъпка за лоялни клиенти. Отстъпката се записва към профила им." : "Данните на клиентите се записват автоматично при поръчка."} />
      {items.length === 0 ? <p className="text-charcoal/50">Все още няма клиенти.</p> : (
        <div className="bg-white border border-stone overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-stone text-navy"><tr><th className="text-left p-3">Клиент</th><th className="text-left p-3 hidden md:table-cell">Телефон</th><th className="text-left p-3 hidden lg:table-cell">Имейл</th><th className="text-left p-3">Поръчки</th><th className="text-left p-3">Изхарчено</th><th className="text-left p-3">Отстъпка</th><th className="p-3"></th></tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-t border-stone" data-testid={`customer-${c.id}`}>
                  <td className="p-3 text-navy font-medium flex items-center gap-2"><Users size={14} className="text-gold" />{c.name}</td>
                  <td className="p-3 hidden md:table-cell text-charcoal/60">{c.phone}</td>
                  <td className="p-3 hidden lg:table-cell text-charcoal/60">{c.email || "—"}</td>
                  <td className="p-3">{c.orders_count || 0}</td>
                  <td className="p-3 text-navy">{formatPrice(c.total_spent || 0)}</td>
                  <td className="p-3">{c.discount_percent ? <span className="flex items-center gap-1 text-gold font-medium"><BadgePercent size={14} />{c.discount_percent}%</span> : "—"}</td>
                  <td className="p-3 text-right"><button onClick={() => setEdit(c)} className="text-navy hover:text-gold" data-testid={`edit-customer-${c.id}`}><Pencil size={15} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {edit && (
        <Modal title={`${edit.name}`} onClose={() => setEdit(null)}>
          <form onSubmit={save}>
            <Field label="Отстъпка за лоялност (%)"><input type="number" min="0" max="100" value={edit.discount_percent || 0} onChange={(e) => setEdit({ ...edit, discount_percent: parseFloat(e.target.value) || 0 })} className={inp} data-testid="customer-discount" /></Field>
            <Field label="Бележка"><textarea value={edit.note || ""} onChange={(e) => setEdit({ ...edit, note: e.target.value })} rows={3} className={inp} /></Field>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm" data-testid="save-customer-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
